document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".countdown-wrap").forEach(function (wrap) {
    const dateStr = wrap.getAttribute("data-end-date");
    const timeStr = wrap.getAttribute("data-end-time") || "00:00:00";

    if (!dateStr) return;

    const [y, m, d] = dateStr.split("-").map(Number);
    const [hh, mm, ss] = timeStr.split(":").map(Number);

    const endTime = new Date(y, m - 1, d, hh || 0, mm || 0, ss || 0).getTime();

    const daysEl = wrap.querySelector('[data-unit="days"]');
    const hoursEl = wrap.querySelector('[data-unit="hours"]');
    const minutesEl = wrap.querySelector('[data-unit="minutes"]');
    const secondsEl = wrap.querySelector('[data-unit="seconds"]');
    const completeEl = wrap.querySelector(".complete-message");

    function tick() {
      const now = Date.now();
      let diff = endTime - now;

      if (diff <= 0) {
        [daysEl, hoursEl, minutesEl, secondsEl].forEach(el => el.textContent = "00");
        if (completeEl) {
          completeEl.textContent =
            wrap.getAttribute("data-complete-message") || "Countdown complete";
          completeEl.classList.add("active");
        }
        return;
      }

      const days = Math.floor(diff / 86400000);
      diff %= 86400000;
      const hours = Math.floor(diff / 3600000);
      diff %= 3600000;
      const minutes = Math.floor(diff / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);

      daysEl.textContent = String(days).padStart(2, "0");
      hoursEl.textContent = String(hours).padStart(2, "0");
      minutesEl.textContent = String(minutes).padStart(2, "0");
      secondsEl.textContent = String(seconds).padStart(2, "0");
    }

    tick();
    setInterval(tick, 1000);
  });
});